module.exports = __webpack_public_path__ + "img/about_logo_01.bcca9ec9.png";